<template>
  <div class="flex basis-full items-stretch lg:basis-4/12">
    <div class="rounded bg-white px-5 py-4 shadow">
      <img
        class="mx-auto mb-4 w-full"
        src="~/assets/images/Te/TeCommon/MentorSupport/IssueReview/ill-mentor-support-review.svg"
        alt="回数無制限の課題レビュー"
        width="339"
        height="191"
        loading="lazy"
      >
      <h2 class="co-display-10 mb-2 text-center font-bold">
        回数無制限の
        <br>
        課題レビュー
      </h2>
      <p class="mb-0">
        学習中に出される課題において、正しく理解できるまで何度でもレビューを受けることができます。
      </p>
    </div>
  </div>
</template>
